// Environment variables shared by the browser bundle and the SSR server.
//
// This module deliberately has no imports. src/server/sentry.js is evaluated
// before setupGlobals defines global.window, so whatever it pulls in must not
// touch `window` at import time. That rules out constants.ts, which imports
// framer-motion — hence this leaf module, which constants.ts re-exports.
//
// Note these behave differently per bundle. DefinePlugin only runs in
// webpack.config.js, not webpack.server.js, so the browser gets build-time
// values while the SSR process looks them up in its real environment at
// runtime. No .env is read there — the server bundle contains no dotenv — so a
// var is undefined unless the process manager passes it in. We will update this in another ticket
export const APP_ENV = process.env.REACT_APP_ENV || 'production';
export const REACT_APP_VERSION = process.env.REACT_APP_VERSION;
export const USE_SENTRY = (process.env.REACT_APP_SENTRY_ENABLED || 'true').toLowerCase() === 'true';
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
